import React, {useRef, useEffect, useState} from 'react';

class Prompt extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            search: '',
            prompt: '',
            loading: false,
            result: null,
            token: 1000,
            temperature: 0,
        };


        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.doPrompt = this.doPrompt.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePromptChange = this.handlePromptChange.bind(this);
        this.handleTokenChange = this.handleTokenChange.bind(this);
        this.handleTemperatureChange = this.handleTemperatureChange.bind(this);
    }

    getClient() {
        return this.clients[this.state.vector]
    }

    handleSearchChange(event) {
        this.setState({'search': event.target.value})
    }

    handlePromptChange(event) {
        this.setState({'prompt': event.target.value})
    }

    handleTokenChange(event) {
        this.setState({'token': event.target.value})
    }

    handleTemperatureChange(event) {
        this.setState({'temperature': event.target.value})
    }

    setLoading(state) {
        this.setState({'loading': state})
    }

    setPromptResult(response) {
        this.setLoading(false);

        this.setState({ 'result': response });
    }

    clearSearchResult(response) {
        this.setState({
            'result': []
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.doPrompt();
    }

    doPrompt() {
        this.setLoading(true);
        
        let params = {
            "prompt": this.state.prompt,
            "search": this.state.search,
            "temperature": this.state.temperature,
            "token": this.state.token
        }

        const requestOptions = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(params) };
        fetch('https://llm-evaluation-api.comsulting.net/prompt/raw/', requestOptions)
            .then(response => response.json())
            .then(this.setPromptResult.bind(this))
            .catch((error) => {
                this.setLoading(false);
                console.error('Error:', error);
                alert("Es ist ein Fehler aufgetreten. In der Konsole finden Sie weitere Informationen. Bitte die Suche erneut starten.")
            });
    }

    render() {
        return (
            <div class="container">
                <h1 class="mt-3">Pythia - Raw Prompt</h1>

                <div class="main-form">
                    <form onSubmit={this.handleSubmit} className="mb-3">
                        <div class="row">
                            <div class="col">
                                <label>Prompt</label>
                                <textarea type="text" class="form-control" value={this.state.prompt} onChange={this.handlePromptChange} rows="10" />
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <label>Suche</label>
                                <input type="text" class="form-control" value={this.state.search} onChange={this.handleSearchChange} />
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6">
                                <label>Token</label>
                                <input type="number" class="form-control" value={this.state.token} onChange={this.handleTokenChange} />
                            </div>
                            <div class="col-6">
                                <label>Temperature</label>
                                <input type="number" class="form-control" value={this.state.temperature} onChange={this.handleTemperatureChange} />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col d-grid">
                                <button class="btn btn-outline-primary" onClick={this.doSearch}  type="submit">Submit!</button>
                            </div>
                        </div>
                        <hr/>
                    </form>

                    { this.state.loading == false && this.state.result != null && (
                        <div class="row">
                            <pre id="json">
                                {JSON.stringify(this.state.result, undefined, 4)}
                            </pre>
                        </div>
                    )}

                    { this.state.loading == true && (
                        <div class="row">
                            <div class="col result">
                                Loading....
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default Prompt;
